import { configureStore } from '@reduxjs/toolkit'
import hospitalSlice from './slices/hospitalSlice'
import authUserSlice from './slices/authUserSlice'

export default configureStore({
  reducer: {
    hospital: hospitalSlice.reducer,
    authUser: authUserSlice.reducer
  }
})